<template>
	<div>
    <div class="chatContainer" v-if="isChatOpen && !isScreenSmall">
      <div class="collapse bg-darkgrey mx-2 py-2" id="chat" >
        <chat-container
					:currentUserId="this.uid"
					:theme="theme"
					:isDevice="this.isScreenSmall"
					@show-demo-options="showDemoOptions = $event"
					v-if="showChat"
				/>
      </div>
    </div>

    <div class="chatContainerMobile" v-if="isChatOpen && isScreenSmall">
      <div class="collapse bg-darkgrey mx-2 py-2" id="chat" v-scroll-lock="isChatOpen">
    		<chat-container
					:currentUserId="this.uid"
					:theme="theme"
					:isDevice="this.isScreenSmall"
					@show-demo-options="showDemoOptions = $event"
					v-if="showChat"
				/>
      </div>
    </div>

    <button @click="toggleChat"
    :class="{'hasMessageBtn': checkHasNewMessage}"
    class="btnChat hasNoMessageBtn bg-darkgrey pb-5" type="button" data-toggle="collapse" data-target="#chat">
      <i v-if="!checkHasNewMessage" class="fa fa-comments"></i>
      <i v-if="checkHasNewMessage" class="fa fa-comments"></i>
    </button>

	</div>
</template>

<script>
import ChatContainer from './ChatContainer.vue'
import _ from 'lodash'

export default {
	components: {
		ChatContainer
	},

	data () {
		return {
			theme: 'light',
			showChat: true,
			currentUserId: this.uid,
			isDevice: false,
			showDemoOptions: true,
			updatingData: false
		}
	},

  created () {
    this.isScreenSmall = window.innerWidth < 800
  },

	methods: {
    onResize: _.debounce(function () {
      this.isScreenSmall = window.innerWidth < 800
    }, 50)
  },

	computed: {
		showOptions () {
			return !this.isDevice || this.showDemoOptions
		},
		checkHasNewMessage () {
      return this.$store.state.hasNewMessage
    },
		uid () {
      return this.$store.state.user.uid
    }
	},

	mounted () {
		this.onResize()
    window.addEventListener('resize', this.onResize, { passive: true })
	},

	watch: {
		currentUserId () {
			this.showChat = false
			setTimeout(() => (this.showChat = true))
		}
	},

  beforeDestroy () {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.onResize, { passive: true })
    }
  }
}
</script>

<style scoped>
.chatContainer {
  background-color: #2c2d2f;
  position: fixed;
  margin-bottom: 3rem;
  z-index: 1001;
  right: 0;
  left: 40%;
  bottom: 0;
}

.chatContainerMobile {
  background-color: #2c2d2f;
  position: fixed;
  z-index: 1001;
  right: 0;
  left: 0;
}

.hasNoMessageBtn {
  transition: all 0.25s ease;
  cursor: pointer;

  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;
  border: 1px solid transparent;
  height: 4rem;
  width: 15%;
  font-size: 2rem;

  position: fixed;
  right: 7rem;
  bottom: -1rem;
  z-index: 1030;
}

/* If user has no unseen messages */
.hasNoMessageBtn:hover {
  color: rgba(255, 255, 255, 0.95) !important;
}


.hasMessageBtn:hover {
  color: #00ff00 !important;
}

.hasMessageBtn{
  animation: pulseAnimation;
  animation-duration: 4s;
	animation-iteration-count: infinite;

  color: #16f216c4 !important;
  bottom:  -1rem;
}

/* If user has unseen messages */
@keyframes pulseAnimation {
  5% {
    bottom: 0rem;
  }

  20% {
    bottom:  -1rem;
  }
}
</style>
